import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from '../../base/base-designer-component';

@Component({
  selector: 'unknown-component',
  template: `<div>Unknown designer Id:{{controlContext.id}} Type:{{controlContext.type}}</div>`
})
export class UnknownDesignerComponent extends BaseDesignerComponent {
  constructor(container: ElementRef) {
      super(container, 'UnknownDesignerComponent');
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/deprecated/unknowDesigner.component.ts